<template>
  <div id="AppVue">
    <link rel="shortcut icon" type="image/png" href="/static/flying.png" />
    <link rel="stylesheet" href="https://bootswatch.com/4/cerulean/bootstrap.min.css"><!-- bootstrap styling resource -->
    <!-- <div id="nav"> -->
    <!--   <router&#45;link to="/">Home</router&#45;link> | -->
    <!--   <router&#45;link to="/about">About</router&#45;link> -->
    <!-- </div> -->

    <router-view/>

  </div><!-- App -->
</template>

<style>
#AppVue {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: '10pt';
  text-align: center;
  /* color: #2c3e50; */
  /* width:100%; */
  /* border: 1px solid black; */
  /* background-color: orange; */
}
#nav {
  /* padding: 30px; */
  /* border: 1px solid black; */
  /* background-color: green; */
}
/* #nav a { */
/*   font-weight: bold; */
/*   color: #995500; */
/* } */
/* #nav a.router-link-exact-active { */
/*   color: #005599; */
/* } */
</style>


<script>
import { Component, Vue } from 'vue-property-decorator';
import Home from '@/views/Home';
import About from '@/views/Home';

export default
@Component({
  components: {
    Home,
    About
  },
})
class App extends Vue {
  mounted(){
    Vue.$log.debug('App.vue mounted');
  }
}
</script>
